import { render, staticRenderFns } from "./outstockCategory.vue?vue&type=template&id=3ed9a463&scoped=true&"
import script from "./outstockCategory.vue?vue&type=script&lang=js&"
export * from "./outstockCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed9a463",
  null
  
)

export default component.exports